import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Globals } from './globals';
import { IStoreSettings } from '../../../../../common/common-interfaces/store-settings';
import { IUser } from '../../../../../common/common-interfaces/user';

@Injectable()
export class Api {
    constructor(private http: HttpClient, private globals: Globals) {

    }

    async loadCurrentUser() {
        try {
            this.globals.currentUser = await this.user().get<IUser>(`/current`);
        }
        catch (e) {
            console.log('No current user');
        }

        if (!this.globals.currentUser && !this.globals.adminKey && !window.location.href.includes('admin/login')) {
            const shopDomain = localStorage.getItem('shopify_shop_domain');
            if (shopDomain) {
                window.location.href = '/shopify-app/?shop=' + encodeURIComponent(shopDomain);
            } else {
                window.location.href = '/admin/login';
            }
        }
    }


    private requester = (baseUrl: string, isAbsolute?: boolean) => {
        let http = this.http;
        let accessCode = this.globals.accessCode as string;
        let adminKey = this.globals.adminKey;
        return {
            get: function <T>(url: string) {
                return http.get(`${baseUrl}${url}`, {
                    withCredentials: true,
                    headers: {
                        'Access-Code': accessCode ? accessCode : '',
                        'Admin-Key': adminKey ? adminKey : ''
                    }
                }).toPromise() as Promise<T>
            },
            post: function <T>(url: string, data: any) {
                return http.post(`${baseUrl}${url}`, data, {
                    withCredentials: true,
                    headers: {
                        'Access-Code': accessCode ? accessCode : '',
                        'Admin-Key': adminKey ? adminKey : ''
                    }
                }).toPromise() as Promise<T>
            },
            put: function <T>(url: string, data: any) {
                return http.put(`${baseUrl}${url}`, data, {
                    withCredentials: true,
                    headers: {
                        'Access-Code': accessCode ? accessCode : '',
                        'Admin-Key': adminKey ? adminKey : ''
                    }
                }).toPromise() as Promise<T>
            },
            patch: function <T>(url: string, data: any) {
                return http.patch(`${baseUrl}${url}`, data, {
                    withCredentials: true,
                    headers: {
                        'Access-Code': accessCode ? accessCode : '',
                        'Admin-Key': adminKey ? adminKey : ''
                    }
                }).toPromise() as Promise<T>
            },
            delete: function <T>(url: string) {
                return http.delete(`${baseUrl}${url}`, {
                    withCredentials: true,
                    headers: {
                        'Access-Code': accessCode ? accessCode : '',
                        'Admin-Key': adminKey ? adminKey : ''
                    }
                }).toPromise() as Promise<T>
            }
        }
    }


    public storeUrl = (path: string = '', store?: IStoreSettings, storeId?: string) => {
        if (storeId)
            return `/api/stores/by-id/${storeId}/admin${path}`;

        if (this.globals.storeId)
            return `/api/stores/by-id/${this.globals.storeId}/admin${path}`;

        if (!store && this.globals.storeSettings)
            store = this.globals.storeSettings;

        return `/api/stores/by-access-code/${store ? store.accessCode : this.globals.accessCode}/admin${path}`;
    };

    public store = (store?: IStoreSettings) => {
        return this.requester(this.storeUrl('', store));
    };

    public storeId = (storeId: string) => {
        return this.requester(this.storeUrl('', null, storeId));
    };

    public admin = () => {
        return this.requester('/api/admin');
    };

    public public = () => {
        return this.requester('/api/public');
    };

    public user = () => {
        return this.requester('/api/user');
    };

    public adminStore = (store?: IStoreSettings) => {
        if (!store)
            store = this.globals.storeSettings;
        return this.requester(`/api/admin/stores/${store.name}`);
    };

}
